import { useContext, useEffect, useState } from "react";
import { Loader } from "@fluentui/react-northstar";
import "./SettingsTab.css";
import { TeamsFxContext } from "./Context";

export default function SettingsTab() {
  const { themeString, teamsfx, inTeams  } = useContext(TeamsFxContext);
  const [currentUserEmail, setCurrentUserEmail] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>();

  useEffect(() => {
    if (inTeams === true) {

      const fetchUserProfile = async () => {
        if (!teamsfx){
          return;
        }

        let userInfo = await teamsfx.getUserInfo();

        setCurrentUserEmail(userInfo.preferredUserName);
        setLoading(false);
      }

      fetchUserProfile()
        .catch((error) => setError(error));;
    }
  }, [inTeams]);

  return (
    <div className={themeString === "default" ? "" : "dark"}>
      <div className="settingstab page">
        <div className="narrow page-padding">
          {loading && (<Loader label="Loading..." />)}


          {!loading && !error && (
            <>
              CyberCare Application Settings
            </>
          )}

          {!loading && error && (
            <div className="error">
              An unexpected error occurred. Please try again later. <br /> Details: {error.toString()}
            </div>
          )}
        </div>
      </div>
    </div> 
  );
}
